import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

export const hasSessionGuard: CanMatchFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const { data } = await auth.getSession();

  return data.session ? router.parseUrl('/cu/dashboard') : false;
};
